<template>
    <!-- <section> -->
      <div class="bg-white bd-radius-5">
        <template v-if="showCart !== 'non-slide'">
          <div class="cart-total">
            <small>
              <i class="fas fa-shopping-cart"></i>
              {{ cart.length }} ชิ้น
            </small>
          </div>
        </template>
        <div 
          class="bg-slider-cart py-1" 
          @click="(showCart !== 'non-slide') ? $emit('openCartComponent','non-slide') : slideCart('slide')"
        >
          <i class="fas fa-chevron-left" v-if="showCart !== 'non-slide'"></i>
          <i class="fas fa-chevron-right" v-else></i>
        </div>
        <div :class="['row' , showCart !== 'non-slide' ? 'pl-4' : '']">
          <div class="col-12">
            <div class="table">
              <div class="d-flex align-items-center mt-3">
                <div class="col-1"></div>
                <div class="col-7 py-2 p-0 d-flex flex-row text-truncate align-items-center">
                  <div class="pl-2">
                    <h3 class="mb-0 dark">รายการสินค้า {{ sender.name }}</h3>
                  </div>
                </div>
                <div class="col-4 py-2 pl-1 pr-3">
                  <button class="btn btn-block py-1 px-0"
                    :class="($THEME.btnCancelBill && !idorder && cart.length) ? 'btn-danger' : 'btn-newbill'"
                    :disabled="total == 0 && sender.name == ''" @click="modalConfirmReset()">
                    <i class="fas fa-circle-notch fa-spin" v-if="isLoadingNewBill"></i>
                    {{ ($THEME.btnCancelBill && !idorder && cart.length) ? 'ยกเลิกรายการทั้งหมด' : 'เปิดบิลใหม่'
                    }}
                  </button>
                </div>
              </div>
              <div class="card-header border-0 dark">
                <div class="row">
                  <div class="col-12">
                    <b-form-group label-for="input-search-recipient" class="mt-2 mb-3 w-100">
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          <i class="fa fa-search text-muted"></i>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="ค้นหาพัสดุด้วยข้อมูลผู้รับ (ชื่อ, เบอร์โทร)"
                          v-model="search.recipient"></b-form-input>
                      </b-input-group>
                    </b-form-group>
                  </div>
                </div>
                <div class="scroll-table scroll-bar-pop scrollbar-style table-responsive">
                  <h3 class="scroll-empty" v-if="total == 0 && !filterCheckKerryDropoff && !filterCheckLazadaDropoff && !filterCheckFlashDropoff">กรุณาเพิ่มสินค้า</h3>
                  <table class="table" v-else>
                    <thead>
                      <tr class="text-center">
                        <th>#</th>
                        <th :class="(checkThemeQuick() ? 'px-5' : '')">ชื่อสินค้า</th>
                        <th class="px-5">ข้อมูลผู้รับ</th>
                        <th>จำนวน</th>
                        <th>ราคา</th>
                        <th>ราคารวม</th>
                        <th>ยอด COD</th>
                        <th>จัดการ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- TODO ได้โปรด ให้มีการ์ดเวลา สักการ์ด มา refectoring ตรงนี้ ไปถึง แก้ไข ใครได้การ์ด ฝากด้วยนะ เวลานานๆเหลือ ก็รบกวนช่วยด้วยนะ -->
                      <template
                        v-for="(item, index) in (search.recipient) ? filteredCartShippingByRecipient : cartShipping">
                        <tr :key="index" :class="[
                          'text-center',
                          { 'tr-error-after-create-order-details': item.error.status },
                          { 'tr-printlabel-after-create-order-details': item.order_detail_id }
                        ]">
                          <td :id="index" :rowspan="(item.error.status) ? 2 : ''">{{ getIndex(0, index) }}</td>
                          <td :rowspan="(item.error.status) ? 2 : ''">

                            <template v-if="item.hasOwnProperty('dropoff_type')">
                              {{ (item.dropoff_type == 'VRICH_DROPOFF' || (item.dropoff_type == 'QUICK_DROPOFF'))
                                  ? item.pre_tracking : item.dropoff_tracking_code
                              }}
                              {{  
                                (item.dropoff_type == 'INTER_BOOK' ? item.courier_name : '')
                              }}
                              {{ (checkShowWeightCart(item)) ? (checkUntiKG() ? item.parcel.weightKG + 'kg' :
                                  item.parcel.weight + 'g') : ''
                              }}
                            </template>
                            <template v-else>
                              {{ item.name }}
                              {{ (checkShowWeightCart(item)) ? (checkUntiKG() ? item.parcel.weightKG + 'kg' :
                                  item.parcel.weight + 'g') : ''
                              }}
                            </template>

                            <br />
                            <b-badge v-if="item.hasOwnProperty('dropoff_type')" variant="primary" class="d-block">
                              {{ item.dropoff_type }}
                            </b-badge>
                            <b-badge v-if="item.cod_amount > 0" variant="info" class="d-block">
                              COD
                            </b-badge>
                          </td>
                          <td>
                            {{ item.to.name }} <br />
                            {{ item.to.tel }}
                          </td>
                          <td>{{ item.num }}</td>
                          <td>{{ item.price | numFormat('0,0.00') }}</td>
                          <td>
                          {{ 
                            (parseFloat(item.price) > 0 ? parseFloat(item.price) : 0) + (parseFloat(item.fuel_surcharge) > 0 ? parseFloat(item.fuel_surcharge) : 0 ) + (parseFloat(item.service_price_inter) > 0 ? parseFloat(item.service_price_inter) : 0) + ( parseFloat(item.travel_surcharge) > 0 ? parseFloat(item.travel_surcharge) : 0 ) + (parseFloat(item.island_surcharge) > 0 ? parseFloat(item.island_surcharge) : 0) + (parseFloat(item.rate_remote_area) > 0 ? parseFloat(item.rate_remote_area) : 0) + (parseFloat(item.cross_price) ? parseFloat(item.cross_price) : 0) + (
                              + (parseFloat(item.extra_handling_charge)>0?parseFloat(item.extra_handling_charge):0) + (item.insurance && parseFloat(item.insurance.listPrice.price) > 0) ?
                              parseFloat(item.insurance.listPrice.price) : 0) | numFormat('0,0.00')
                          }}
                            <br v-if="item.rate_remote_area > 0" />
                            <span class="small text-danger tooltip-target-1" v-if="item.rate_remote_area > 0"
                              v-b-tooltip title="ค่าบริการพิ้นที่พิเศษ">(+ {{ item.rate_remote_area }})</span>
                            <br v-if="item.travel_surcharge > 0" />
                            <span class="small text-danger tooltip-target-1" v-if="item.travel_surcharge > 0"
                              v-b-tooltip title="ค่าบริการพื้นที่ท่องเที่ยว">(+ {{ item.travel_surcharge }})</span>
                            <br v-if="item.island_surcharge > 0" />
                            <span class="small text-danger tooltip-target-1" v-if="item.island_surcharge > 0"
                              v-b-tooltip title="ค่าพื้นที่หมู่เกาะ">(+ {{ item.island_surcharge }})</span>
                            <br v-if="item.fuel_surcharge > 0" />
                            <span class="small text-danger tooltip-target-1" v-if="item.fuel_surcharge > 0"
                              v-b-tooltip title="Additional Fuel Charge">(+ {{ item.fuel_surcharge }})</span>
                            <br v-if="item.extra_handling_charge > 0" />
                            <span class="small text-danger tooltip-target-1" v-if="item.extra_handling_charge > 0"
                              v-b-tooltip title="Extra Handling Charge">(+ {{ item.extra_handling_charge }})</span>
                            <br v-if="item.cross_price > 0" />
                            <span class="small text-danger tooltip-target-1" v-if="item.cross_price > 0"
                              v-b-tooltip title="ค่าบริการข้ามภาค">(+ {{ item.cross_price }})</span>
                            <br v-if="item.service_price_inter > 0" />
                            <span class="small text-danger tooltip-target-1" v-if="item.service_price_inter > 0"
                              v-b-tooltip title="ค่าบริการส่งต่างประเทศ">(+ {{ item.service_price_inter }})</span>
                            <template v-if="item.insurance && item.insurance.listPrice.price > 0">
                              <br />
                              <span class="small text-danger tooltip-target-1" v-b-tooltip
                                title="ค่าบริการประกันพัสดุ">(+ {{ item.insurance.listPrice.price }})</span>
                            </template>
                          </td>
                          <td>{{ item.cod_amount | numFormat('0,0.00') }}</td>
                          <td>
                            <div class="d-flex">
                              <button
                                v-if="checkThemeQuick() && (item.hasOwnProperty('courier') && !item.courier.prebarcode)"
                                class="btn btn-link text-indigo p-2 hvr-grow" :disabled="filterCheckKerryDropoff || filterCheckLazadaDropoff"
                                @click="switchPrintLabel(item)">
                                <i class="fas fa-print"></i>
                              </button>

                              <button v-else class="btn btn-link text-info p-2 hvr-grow"
                                :disabled="idorder != '' || filterCheckKerryDropoff || filterCheckLazadaDropoff"
                                @click="editParcel(item.check)">
                                <i class="fas fa-edit"></i>
                              </button>

                              <button class="btn btn-link text-danger p-2 hvr-grow" :disabled="idorder != ''"
                                @click="checkBeforeRemoveTotal(item.check)">
                                <i class="far fa-trash-alt"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr :key="`error-msg-${index}`" v-if="item.error.status">
                          <td colspan="6" class="text-center tr-error-after-create-order-msg">
                            {{ item.error.msg }}
                          </td>
                        </tr>
                      </template>
                      <template v-for="(item, index) in cartItem">
                        <tr :key="item.id" class="text-center">
                          <td>{{ getIndex(cartShipping.length, index) }}</td>
                          <td>{{ item.name }}</td>
                          <td> - </td>
                          <td>
                            <number-input size="small" @change="reload(item)" v-model="item.num" :min="1" inline
                              controls class="input-product-table" :disabled="idorder != ''"></number-input>
                          </td>
                          <td>{{ item.price | numFormat('0,0.00') }}</td>
                          <td>{{ item.qtytotal | numFormat('0,0.00') }}</td>
                          <td>{{ '-' }}</td>
                          <td>
                            <button class="btn btn-link text-danger hvr-grow" :disabled="idorder != ''"
                              @click="removeTotal(item.check)">
                              <i class="far fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      </template>
                      <template v-for="(item, index) in cartService">
                        <tr :key="item.check" class="text-center">
                          <td>{{ getIndex(cartShipping.length + cartItem.length, index) }}</td>
                          <td>
                            <template v-if="item.name === 'shippop inter parcel'">
                              {{ item.trackingCode }}<br />
                              <div class="overflow-table-order">
                                <span class="small">{{ item.from }}</span>
                                <br />
                                <span class="small text-info">{{ '(พัสดุต่างประเทศ)' }}</span>
                              </div>
                            </template>
                            <template v-else>
                              {{ item.name }}
                            </template>
                          </td>
                          <td> - </td>
                          <td>{{ item.num }}</td>
                          <td>{{ item.price | numFormat('0,0.00') }}</td>
                          <td>{{ item.price | numFormat('0,0.00') }}</td>
                          <td>{{ '-' }}</td>
                          <td>
                            <button class="btn btn-link text-danger hvr-grow" :disabled="idorder != ''"
                              @click="removeTotal(item.check)">
                              <i class="far fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      </template>
                      <template v-for="( item, index ) in cartDropoffShippop">
                        <tr :key="index" class="text-center">
                          <td>{{ getIndex(cartShipping.length + cartItem.length + cartService.length, index) }}
                          </td>
                          <td>{{ item.barcode }}</td>
                          <td> - </td>
                          <td>{{ '1' }}</td>
                          <td>{{ '-' }}</td>
                          <td>{{ item.price | numFormat('0,0.00') }}</td>
                          <td>{{ '-' }}</td>
                          <td>
                            <button class="btn btn-link text-danger hvr-grow" :disabled="idorder != ''"
                              @click="removeTotal(index, DROPOFF_SP)">
                              <i class="far fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      </template>
                      <template v-for="(item, index) in cartInsurance">
                        <tr :key="item.check" class="text-center">
                          <td>{{
                              getIndex(cartShipping.length + cartItem.length + cartService.length +
                                cartDropoffShippop.length, index)
                          }}</td>
                          <td>{{ item.name }}</td>
                          <td> - </td>
                          <td>{{ item.num }}</td>
                          <td>{{ item.price | numFormat('0,0.00') }}</td>
                          <td>{{ item.price | numFormat('0,0.00') }}</td>
                          <td>{{ '-' }}</td>
                          <td>
                            <button class="btn btn-link text-danger hvr-grow" :disabled="idorder != ''"
                              @click="removeTotal(item.check)">
                              <i class="far fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      </template>
                      <template v-for="(item, index) in cartEVoucher">
                        <tr :key="item.check" class="text-center">
                          <td>{{
                              getIndex(cartShipping.length + cartItem.length + cartService.length +
                                cartDropoffShippop.length + cartInsurance.length, index)
                          }}</td>
                          <td>{{ item.name }}
                            <br />
                            <span class="small">({{ item.barcode }})</span>
                          </td>
                          <td> - </td>
                          <td>{{ item.num }}</td>
                          <td>{{ item.price | numFormat('0,0.00') }}</td>
                          <td>{{ item.price | numFormat('0,0.00') }}</td>
                          <td>{{ '-' }}</td>
                          <td>
                            <button class="btn btn-link text-danger hvr-grow" :disabled="idorder != ''"
                              @click="removeTotal(item.check)">
                              <i class="far fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      </template>
                      <template v-for="(item, index) in cartZendai">
                        <tr :key="item.check" class="text-center">
                          <td>{{
                              getIndex(cartShipping.length + cartItem.length + cartService.length +
                                cartDropoffShippop.length + cartInsurance.length + cartEVoucher.length, index)
                          }}</td>
                          <td>{{ item.name }}</td>
                          <td> - </td>
                          <td>{{ item.num }}</td>
                          <td>{{ item.price | numFormat('0,0.00') }}</td>
                          <td>{{ item.price | numFormat('0,0.00') }}</td>
                          <td>{{ '-' }}</td>
                          <td>
                            <button class="btn btn-link text-danger hvr-grow" :disabled="idorder != ''"
                              @click="removeTotal(item.check)">
                              <i class="far fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <template v-if="showCart === 'non-slide'">
              <div class="col-12">
                <div class="group-result">
                  <div class="price">

                    <h6>ยอดรวมทั้งหมด <small v-if="idorder && checkBill.discountAmount > 0">(รวมส่วนลด)</small></h6>
                    <h1>
                      <template v-if="idorder && checkBill.discountAmount > 0">
                        <span class="text-muted number-discount px-2">{{ total | numFormat('0,0.00') }}</span>
                        <span>{{ (total - checkBill.discountAmount) | numFormat('0,0.00') }} </span>
                      </template>
                      <template v-else>
                        {{ total | numFormat('0,0.00') }}
                      </template>
                      <small>บาท</small>
                    </h1>
                  </div>
                </div>
                <!-- <div class="w-100 px-3" role="group" aria-label="Basic example">
                  <button
                    type="button"
                    :disabled="total == 0 || idorder != '' || ( filterCheckOrderDetailId && !filterCheckDropoffVRich )"
                    class="btn btn-success py-3 btn-block"
                    @click="beforeCheckbill()"
                  >รับเงิน</button> -->
                <!-- v-b-modal.modal-checkbill -->
                <!-- </div> -->
              </div>
              <div class="col-12">
                <div class="group-btn-etc row p-3 mt-1">
                  <div class="col-3 px-2">
                    <router-link :to="printReceipt(idorder)" target="_blank">
                      <button class="btn btn-receipt btn-block py-3" :disabled="!idorder">
                        <!-- <i class="far fa-file-alt"></i>  -->
                        ใบเสร็จ
                      </button>
                    </router-link>
                  </div>
                  <div class="col-3 px-2">
                    <router-link :to="setPatchPrintLabel()" target="_blank">
                      <button class="btn btn-label btn-block py-3"
                        :disabled="(!labeltype || shippop == 0) && !labeltypeDropoff">
                        ใบปะหน้า
                      </button>
                    </router-link>
                  </div>
                  <div class="col-6 px-2">
                    <button type="button"
                      :disabled="total == 0 && !filterCheckKerryDropoff && !filterCheckLazadaDropoff && !filterCheckFlashDropoff
                      || idorder != ''
                      || (
                          filterCheckOrderDetailId 
                          && !filterCheckDropoffVRich
                          && !filterCheckDropoffPanPan
                          && !filterCheckKerryDropoff
                          && !filterCheckLazadaDropoff
                          && !filterCheckDropoffQuick
                          && !filterCheckFlashDropoff
                        )"
                      class="btn btn-success py-3 btn-block" @click="beforeCheckbill()">
                      รับเงิน
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    <!-- </section> -->
</template>

<script>
export default {
    props: {
        selectedCourier: [Object, String],
        label: String,
        typeOfLabel: String,
        showCart: String,
        sender: Object,
        idorder: [String, Number],
        cart: Array,
        search: Object,
        checkBill: Object,
        labeltype: [String, Number],
        shippop: [String, Number],
        labeltypeDropoff: String,
        isLoadingNewBill: Boolean,
        total: [Function, Number],
        modalConfirmReset: Function,
        checkThemeQuick: Function,
        checkUntiKG: Function,        
        cartShipping: [Function, Array],
        switchPrintLabel: Function,
        editParcel: Function,
        checkBeforeRemoveTotal: Function,
        reload: Function,
        removeTotal: Function,
        cartDropoffShippop: [Function, Array],
        filterCheckLazadaDropoff: [Function, Boolean],
        filterCheckKerryDropoff: [Function, Boolean],
        filterCheckOrderDetailId: [Function, Boolean],
        filterCheckDropoffVRich: [Function, Boolean],
        filterCheckDropoffQuick: [Function, Boolean],
        filterCheckDropoffPanPan: [Function, Boolean],
        filterCheckDropoffINTER: [Function, Boolean],
        filterCheckDropoffLAO: [Function, Boolean],
        filterCheckFlashDropoff: [Function, Boolean],
        beforeCheckbill: [Function]
    },
    computed: {
        filteredCartShippingByRecipient() {
            return this.cartShipping.filter(order => {
                return order.to.name.toLowerCase().includes(this.search.recipient.toLowerCase()) ||
                order.to.tel.toLowerCase().includes(this.search.recipient.toLowerCase())
            })
        },
        cartItem() {
            return this.cart.filter(item => {
                return item.type === "item";
            });
        },
        cartZendai() {
            return this.cart.filter(item => {
                return item.type === "zendai";
            });
        },
        cartService() {
            return this.cart.filter(item => {
                return item.type === "service";
            });
        },
        cartInsurance() {
            return this.cart.filter(item => {
                return item.type === "insurance";
            });
        },
        cartEVoucher() {
            return this.cart.filter(item => {
                return item.type === "eVoucher";
            });
        },
    },
    methods: {
      slideCart(key) {
        return this.$emit('slideCart', key)
      },
      printReceipt(order_id) {
        this.recheckCutOrderDraft = true
        return `receipt/${order_id}`;
      },
      setPatchPrintLabel() {
          //  <!-- :to="`/label/${idorder}/${label}/${typeOfLabel}`" -->
          this.recheckCutOrderDraft = true
          if (this.filterCheckDropoffVRich || this.filterCheckDropoffPanPan) {
              let trackingCodes = []
              let dropoffType = ""
              
              if( this.filterCheckDropoffVRich ){
                dropoffType = "VRICH_DROPOFF";
              }else if( this.filterCheckDropoffPanPan ){
                dropoffType = "PANPAN_DROPOFF";
              }

              this.cartShipping.forEach(item => {
                trackingCodes.push(item.shippop_tracking_code)
              })
              trackingCodes = trackingCodes.join()
              return `/label/${trackingCodes}/${this.label}/${dropoffType}`
          }else if ( this.filterCheckDropoffINTER || this.filterCheckDropoffLAO ) {
            return `/label/inter/${this.idorder}/${this.typeOfLabel}`
          }
          return `/label/${this.idorder}/${this.label}/${this.typeOfLabel}`
      },
      getIndex(start, index) {
          index++;
          return start + index
      },
      checkShowWeightCart(order) {
          return order.hasOwnProperty('parcel') && (this.checkUntiKG() ? 
          order.parcel.hasOwnProperty('weightKG') : order.parcel.hasOwnProperty('weight'))
      },
    }
}
</script>